import { useState } from 'react'
import { Button } from '@wove/web-ui'
import SourceTable from '@src/Pages/UploadPage/SourceTable'
import { useGetSourcesQuery } from '@wove/api'
import { useAuth } from '@src/hooks/useAuth'
import RequestAccessModal from '@src/Pages/UploadPage/RequestAccessModal'
import FileUploadSection from '@src/Components/FileUploadSection'

const UploadPage = () => {
  const { customer } = useAuth()
  const [requestAccessOpen, setRequestAccessOpen] = useState(false)
  const [queryData] = useGetSourcesQuery()
  return (
    <div className="flex flex-col gap-6 p-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-bold tracking-tight">Upload Files</h1>
        <p className="text-muted-foreground">Upload your shipping rate data files for processing</p>
      </div>
      {customer?.rateIngestion?.enabled ? (
        <>
          <FileUploadSection />
          {queryData.data?.getSources && <SourceTable sources={queryData.data.getSources} />}
        </>
      ) : (
        <>
          <div className="container mx-auto py-32">
            <div className="flex flex-col items-center">
              <p className="text-center mb-6 text-2xl font-semibold">
                Rate ingestion is not available for your company at the moment.
              </p>
              <Button variant="default" onClick={() => setRequestAccessOpen(true)}>
                Request Access
              </Button>
            </div>
          </div>
          <RequestAccessModal
            onClose={() => setRequestAccessOpen(false)}
            isOpen={requestAccessOpen}
          />
        </>
      )}
    </div>
  )
}

export default UploadPage
